import { render } from "./SummaryConsents.vue?vue&type=template&id=9c08399c&ts=true"
import script from "./SummaryConsents.vue?vue&type=script&lang=ts"
export * from "./SummaryConsents.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__